import {Component, OnDestroy} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {ActionsSubject} from "@ngrx/store";
import {ofType} from "@ngrx/effects";
import {actionTextToSpeechCreateReply, actionTextToSpeechCreateSend, actionTextToSpeechUploadReply, actionTextToSpeechUploadSend} from "../../../store/actions/user.actions";
import {StoreSelectorsService} from "../../../services";
import {isNullOrUndefOrEmpty, popupWindow} from "../../../common";
import {MatDialog} from "@angular/material/dialog";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";

// download dir:
//
//      https://drive.google.com/file/d/1U8q4tXlkVxomJ2FaIK2WTsC8T1uN_TRN/view?usp=sharing
//          https://mstutorials.s3.us-west-2.amazonaws.com/xxx/audio.mp3
//          https://mstutorials.s3.us-west-2.amazonaws.com/xxx/video.mp4
//          https://mstutorials.s3.us-west-2.amazonaws.com/xxx/subtitle_en.tts

@Component({
    selector: 'app-dynawebs-text-to-speech',
    styleUrls: [`./dynawebs-text-to-speech.scss`],
    templateUrl: './dynawebs-text-to-speech.html'
})

export class DynawebsTextToSpeech extends Compbaser implements OnDestroy {
    data = '';
    password = '';
    videoName = '';
    downloadUrl = '';
    globalDisabled = false;
    selectedOption = 'textOption';


    constructor(private actionsSubj: ActionsSubject, private storeSelector: StoreSelectorsService, protected override dialog?: MatDialog) {
        super();
        this.setMe('app-dynawebs-text-to-speech');
        this.cod(
            this.actionsSubj.pipe(ofType(actionTextToSpeechCreateReply))
                .subscribe((reply) => {
                    if (reply.payload.finalUrl) {
                        alert('final urls: ' + reply.payload.finalUrl);
                    } else {
                        alert(reply.payload.status);
                    }
                    this.globalDisabled = false;
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionTextToSpeechUploadReply))
                .subscribe((reply) => {
                    if (reply.payload.finalUrls) {
                        alert('final url: ' + JSON.stringify(reply.payload.finalUrls));
                    } else {
                        alert(reply.payload.status);
                    }
                    this.globalDisabled = false;
                })
        );
    }

    checkFormat(str) {
        const vttRegex = new RegExp(
            '^WEBVTT\\r?\\n\\r?\\n' +               // "WEBVTT" + two newlines
            '(?:' +
            '\\d{2}:\\d{2}:\\d{2}\\.\\d{3}' +     // First timestamp HH:MM:SS.xxx
            '\\s+-->\\s+' +                      // Literal " --> " (with required whitespace on both sides)
            '\\d{2}:\\d{2}:\\d{2}\\.\\d{3}' +     // Second timestamp HH:MM:SS.xxx
            '\\r?\\n' +                          // A newline
            '(?:[^\\r\\n]+\\r?\\n)+' +           // One or more lines of text (subtitles), each followed by a newline
            '\\r?\\n?' +                         // Optional blank line
            ')+' +
            '$',
            'm'
        );
        return vttRegex.test(str);
    }


    toUrlFriendly(str) {
        let s = str.replace(".mp4", "");
        s = s.replace(".mp3", "");
        s = s.replace(".vtt", "");
        return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    get disabledButtonCreate(): boolean {
        return !this.data.trim();
    }

    get disabledButtonUpload(): boolean {
        return !this.downloadUrl.trim() || !this.password.trim();
    }

    onCreateTTS() {
        if (this.data.length != 0 && !this.checkFormat(this.data)) {
            return alert('not correct TTS format');
        }
        this.globalDisabled = true;
        this.storeSelector.dispatch(actionTextToSpeechCreateSend({payload: {data: this.data}}));
    }

    onUploadTTS() {
        if (isNullOrUndefOrEmpty(this.downloadUrl) || isNullOrUndefOrEmpty(this.password)) {
            return alert('no url or password');
        }
        if (this.downloadUrl.length < 7) {
            return alert('name too short');
        }
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: `generate final release?`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.globalDisabled = true;
                this.storeSelector.dispatch(actionTextToSpeechUploadSend({
                        payload: {
                            data: this.data,
                            finalVersion: this.downloadUrl,
                            password: this.password,
                            videoName: this.toUrlFriendly(this.videoName)
                        }
                    })
                );
            }
        });
    }

    openDir() {
        const url = 'https://secure.digitalsignage.com/listTutorials';
        const win = popupWindow({url, title: 'Directory tutorials', h: '300', w: '400'});
    }
}




